@use "../Clickables/index.module.scss" as *;
@use "../../styles/breakpoint.module.scss" as *;

.richText {
    :where(h1, h2) {
        margin-block: var(--spacer-48) var(--spacer-16);
        font: var(--font-h-56);
    }

    :where(h3) {
        margin-block: var(--spacer-40) var(--spacer-16);
        font: var(--font-h-40);
    }

    :where(h4) {
        margin-block: var(--spacer-32) var(--spacer-16);
        font: var(--font-h-32);
    }

    :where(h5, h6) {
        margin-block: var(--spacer-24) var(--spacer-16);
    }

    :where(h5) {
        font: var(--font-h-24);
    }

    :where(h6) {
        font: var(--font-h-20);
    }

    :where(h1, h2, h3, h4, h5, h6) {
        b {
            font-weight: inherit;
        }
    }

    :where(p) {
        margin-block: var(--spacer-16);
    }

    :where(p, li) {
        font: var(--font-p-18);

        i {
            font-style: italic;
        }
    }

    :where(ul, ol) {
        margin-block: var(--spacer-16);
    }

    :where(ul) {
        padding-left: 1.5em;

        ::marker {
            color: var(--robins-blue);
            font-size: 1.2em;
        }

        li {
            padding-left: 0.3em;
        }
    }

    :where(ol) {
        padding-left: 1.2em;

        ::marker {
            content: "";
        }

        li {
            position: relative;
            counter-increment: level1;
            padding-left: 0.8em;

            &::before {
                content: counter(level1) " ";
                position: absolute;
                top: 0;
                left: 0;
                width: 1.714em;
                height: 1.714em;
                display: flex;
                align-items: center;
                justify-content: center;
                background: var(--robins-blue);
                border-radius: 999px;
                font-size: 0.778em;
                font-weight: 700;
                transform: translate(-75%, 15%);
                z-index: 0;
            }
        }
    }

    :where(li) {
        margin-block: var(--spacer-12);
    }

    a {
        color: inherit;
        text-underline-offset: 0.1875em;

        &:focus-visible {
            border-radius: 4px;
            outline: var(--outline);
            outline-offset: 1px;
        }
    }

    a:where(:global(.buttonFilled)) {
        @include filled-button;

        margin-top: var(--spacer-8);
    }

    a:global(.buttonBorderless) {
        @include borderless-button;
    }

    :global(.eyebrow) {
        font: var(--font-eyebrow-14);
        letter-spacing: 0.08em;
        text-transform: uppercase;

        + :is(h1, h2, h3, h4, h5, h6) {
            margin-top: var(--spacer-8);
        }
    }

    img {
        display: inline;
    }

    hr {
        border-top: 0;
        border-bottom-style: solid;
        border-color: var(--color-contrast);
    }
}

.richTextBlock {
    :where(h1, h2, h3, h4) {
        margin-bottom: var(--spacer-24);
    }
}

.large {
    h1 {
        font: var(--font-h-80);
    }

    h2 {
        font: var(--font-h-64);
    }

    h3 {
        font: var(--font-h-56);
    }
}

.extraLarge {
    :where(h1, h2, h3) {
        font: var(--font-h-96);
    }
}

.constrainHalf {
    :where(p, li) {
        @media ($above-tablet) {
            max-width: 50vw;
        }
    }
}

.constrainTwoThirds {
    :where(p, li) {
        @media ($above-tablet) {
            max-width: 67vw;
        }
    }
}

.constrainCenter {
    :where(p, li) {
        @media ($above-tablet) {
            margin-inline: auto;
        }
    }
}

.none {
    visibility: visible;
}

.firstChild {
    > *:first-child {
        margin-top: 0;
    }
}

.lastChild {
    > *:last-child {
        margin-bottom: 0;
    }
}

.both {
    composes: firstChild;
    composes: lastChild;
}

.left {
    text-align: left;
}

.center {
    text-align: center;
}
